// extracted by mini-css-extract-plugin
module.exports = {"about":"About-styles-module--about--1DNiU","dark":"About-styles-module--dark--1Qi8R","nomargin":"About-styles-module--nomargin--3VlR-"};